export const FindCustomerNumberRoutes: import('vue-router').RouteConfig[] = [
	{
		path: '/find-customer-number',
		component: () => import('./pages/master.vue').then((m) => m.default),
		children: [
			{ path: `your-details`, component: () => import('./pages/index.vue').then((m) => m.default), },
			{ path: '', redirect: 'your-details', },
		],
	},
];
